import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const legal_previous_legal_insurance = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('legal_insurance_in_last_5y')]:
        BaseSchema_LegalBasis3BasicRolandDe.shape.legal_insurance_in_last_5y,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_3.insurance_owned.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('legal_insurance_in_last_5y'),
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_3.insurance_owned.info.text',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('legal_insurance_in_last_5y'),
      valueToStepName: {
        false: 'legal_tenant',
        true: 'legal_previous_insurance_carrier',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default legal_previous_legal_insurance
